// Marks the window between the user asking to sign out and the app actually leaving.
//
// Logout revokes the session server-side, so any request already in flight when that
// lands comes back 401 with reason REVOKED — which maps to ENDED, the reason meaning
// "you did not ask for this". The 401 handler would then redirect first and tell a user
// who deliberately clicked Log out that their session had ended unexpectedly.

/**
 * Time-bounded rather than a latch: a flag left set by a logout that never completed
 * would swallow every later 401 redirect, which is worse than the message it prevents.
 * Generous next to a logout round trip, short next to a session.
 */
export const INTENTIONAL_SIGN_OUT_WINDOW_MS = 30 * 1000;

let signOutStartedAt = 0;

/** Call immediately before asking the server to end the session. */
export const beginIntentionalSignOut = (): void => {
	signOutStartedAt = Date.now();
};

export const isSigningOutIntentionally = (): boolean =>
	signOutStartedAt > 0 && Date.now() - signOutStartedAt < INTENTIONAL_SIGN_OUT_WINDOW_MS;

/** Ends the window early, for a sign-out that was abandoned. Also a test seam. */
export const resetIntentionalSignOut = (): void => {
	signOutStartedAt = 0;
};
